module.exports = __webpack_public_path__ + "img/avatar_default_9.e0bd3e3a.svg";